import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import Login from '@/components/Login'

import MainLayout from '@/components/layout/MainLayout'
import Process from '@/components/Process'
import ProcessList from '@/components/ProcessList'
import FileManager from '@/components/files/FileManager'
import Region from '@/components/Region'
import Map from '@/components/map/Map'

import NotFound from '@/components/NotFound'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        path: '',
        name: 'New Analysis',
        component: Process
      },
      {
        path: 'processList',
        name: 'Process List',
        component: ProcessList
      },
      {
        path: 'fileManager',
        name: 'File Manager',
        component: FileManager
      },
      {
        path: 'regions',
        name: 'Regions',
        component: Region
      },
      {
        path: 'map',
        name: 'Map',
        component: Map,
        props: { mapId: 'map' }
      }
    ]
  },
  { // Capturar rutas no existentes
    path: '*',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach(function (to, from, next) {
  let token = store.getters['auth/accessToken']
  if (!token && to.name !== 'Login') {
    router.push('/login')
  } else if (token && to.name === 'Login') {
    router.push('/')
  }

  next()
})

export default router
